export class WorkDay {
  dayOfWeek: number;
  startTimeMinutes: number;
  endTimeMinutes: number;

  constructor(dayOfWeek: number, startTimeMinutes: number, endTimeMinutes: number) {
    this.dayOfWeek = dayOfWeek;
    this.startTimeMinutes = startTimeMinutes;
    this.endTimeMinutes = endTimeMinutes;
  }

  static fromResponse(data: any): WorkDay {
    return new WorkDay(data.dayOfWeek, data.startTimeMinutes, data.endTimeMinutes);
  }

  getStartTimeFormatted(): string {
    const hours = Math.floor(this.startTimeMinutes / 60);
    const minutes = this.startTimeMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  getEndTimeFormatted(): string {
    const hours = Math.floor(this.endTimeMinutes / 60);
    const minutes = this.endTimeMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  getDayName(): string {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[this.dayOfWeek];
  }
}

export class WorkSchedule {
  days: WorkDay[];

  constructor(days: WorkDay[]) {
    this.days = days;
  }

  static fromResponse(data: any): WorkSchedule {
    return new WorkSchedule(data.days.map((day: any) => WorkDay.fromResponse(day)));
  }

  static getDefaultWorkSchedule(): WorkSchedule {
    return new WorkSchedule([
      new WorkDay(1, 9 * 60, 17 * 60), // Monday
      new WorkDay(2, 9 * 60, 17 * 60), // Tuesday
      new WorkDay(3, 9 * 60, 17 * 60), // Wednesday
      new WorkDay(4, 9 * 60, 17 * 60), // Thursday
      new WorkDay(5, 9 * 60, 17 * 60), // Friday
    ]);
  }
}
